module.exports = __webpack_public_path__ + "static/media/ci-cd.fd335acf.svg";